import "core-js/modules/es.string.starts-with.js";
export default defineNuxtRouteMiddleware(function (to) {
  // This makes sure that no routes in legacy/ are available through path routing
  // outside of the i18n configuration.
  if (to.path.startsWith('/legacy')) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page Not Found'
    });
  }
});